<template>
    <div>
        <div class="page-filter-box">
            <el-row :gutter="20">
                <el-col :xs="24" :sm="12" :md="8" :lg="8" :xl="4">
                    <el-input v-model="params.value" class="input-with-select" size="small">
                        <el-select v-model="params.type" slot="prepend" placeholder="请选择">
                            <el-option label="优惠券ID" :value="1"></el-option>
                            <el-option label="优惠券名称" :value="2"></el-option>
                        </el-select>
                    </el-input>
                </el-col>
				<el-col :xs="24" :sm="12" :md="8" :lg="8" :xl="4">
					<el-select v-model="params.couponType" placeholder="请选择" size="small">
						<el-option label="不限制优惠券类型" value=""></el-option>
						<el-option label="仅看普通优惠券" :value="1"></el-option>
						<el-option label="仅看特权购优惠券" :value="2"></el-option>
					</el-select>
				</el-col>
                <el-col :xs="24" :sm="12" :md="8" :lg="8" :xl="4">
                    <el-select v-model="params.couponCategory" placeholder="请选择" size="small">
                        <el-option label="不限制业务范围" value=""></el-option>
                        <el-option label="仅看演出可用的" :value="1"></el-option>
                        <!-- <el-option label="仅看众筹可用的" :value="2"></el-option> -->
                        <el-option label="仅看周边可用的" :value="3"></el-option>
                    </el-select>
                </el-col>
                <el-col :xs="24" :sm="12" :md="16" :lg="11" :xl="8">
                    <div class="clearfix timeType">
                        <el-input class="input-with-select fl" size="small">
                            <el-select v-model="params.dateType" slot="prepend" placeholder="请选择">
                                <el-option label="生效时间" :value="1"></el-option>
                                <el-option label="截止时间" :value="2"></el-option>
                            </el-select>
                        </el-input>
                        <el-date-picker
                            v-model="params.date"
                            type="datetimerange"
                            start-placeholder="开始时间"
                            end-placeholder="结束时间"
                            class="fl"
                            size="small"
                            :default-time="['00:00:00', '23:59:59']"
                            value-format="yyyy-MM-dd HH:mm:ss"
                            unlink-panels
                            >
                        </el-date-picker>
                    </div>
                </el-col>
                <el-col :xs="24" :sm="12" :md="8" :lg="5" :xl="4" class="page-filter-btns">
                    <el-button type="primary" icon="el-icon-search" @click="search" size="small">查询</el-button>
                    <el-button type="default" icon="el-icon-refresh" @click="reset" size="small">重置</el-button>
                </el-col>
            </el-row>
        </div>
        <div class="page-btns-box">
            <el-button  type="primary"  size="small" @click="addCoupon">创建优惠券</el-button>
			<el-button  type="primary"  size="small" @click="redemptionDetail()" >兑换码明细</el-button>
        </div>
        <div class="page-list-box">
            <el-table
                :data="dataList"
                border
                style="width: 100%"
                v-loading="listLoading"
                size="small"
                stripe
            >
                <el-table-column prop="id" label="优惠券ID" :min-width="110"></el-table-column>
                <el-table-column prop="name" label="优惠券名称" :min-width="150" show-overflow-tooltip></el-table-column>
				<el-table-column label="优惠券类型" min-width="100">								
					<template slot-scope="scope">
						<span v-if="scope.row.couponType === 1">普通优惠券</span>
						<span v-else-if="scope.row.couponType === 2">特权购优惠券</span>
					</template>
				</el-table-column>
                <el-table-column prop="couponPrice" label="金额" :min-width="110"></el-table-column>
				<el-table-column label="库存" :min-width="110">
					<!-- 优惠券库存：0 为不限制，特权购优惠券不涉及库存展示为 - -->
					<template slot-scope="scope">
                        <div v-if="scope.row.couponType === 1">
                            <p>已领取：{{ scope.row.receivedCount || 0 }}</p>
						    <p>总库存：{{ stockView(scope.row.stock) }}</p>
                        </div>
						<span v-else></span>
					</template>
				</el-table-column>
				<el-table-column prop="subsidyStr" label="承担方" :min-width="110" show-overflow-tooltip></el-table-column>
                <el-table-column label="有效期" :min-width="300">
                    <template slot-scope="scope">
                        {{`${scope.row.beginTime} 至 ${scope.row.endTime}`}}
                    </template>
                </el-table-column>
                <el-table-column label="使用终端"
                >
                    <template slot-scope="scope">
                        <span v-if="scope.row.useTerminal === 0">全平台</span>
                        <span v-else-if="scope.row.useTerminal === 1">WEB</span>
                        <span v-else-if="scope.row.useTerminal === 2">WAP</span>
                        <span v-else-if="scope.row.useTerminal === 3">APP</span>
                    </template>
                </el-table-column>
                <el-table-column prop="category" label="业务范围" :min-width="110">
                    <template slot-scope="scope">{{category[scope.row.category]}}</template>
                </el-table-column>
                <el-table-column fixed="right" label="操作" :width="400">
                    <template slot-scope="scope">
                        <el-button type="text" size="small" @click="manage(scope.row)" >管理</el-button>
                        <el-button v-if="scope.row.isOver === 1 && scope.row.couponType === 1 " type="text" size="small" @click="issue(scope.row)" >发放</el-button>
						<el-button v-if="scope.row.isOver === 1 && scope.row.couponType === 2 " type="text" size="small" @click="issueTequan(scope.row)" >发放</el-button>
                        <el-button type="text" size="small" @click="viewLink(scope.row)"  v-if="scope.row.couponType === 1 ">领取地址</el-button>
						<el-button type="text" size="small" @click="createCode(scope.row)"  v-if="scope.row.couponType === 1 ">生成兑换码</el-button>
                        <el-button type="text" size="small" @click="viewUsageDetails(scope.row)" >使用明细</el-button>
						<el-button type="text" size="small" @click="userProfile(scope.row)" >用户画像</el-button>
                        <el-button type="text" size="small" @click="delConfirm(scope.row)" >删除</el-button>
                    </template>
                </el-table-column>
            </el-table>
        </div>
        <div v-if="data" class="page-pagination-box">
            <el-pagination
                background
                @size-change="handleSizeChange"
                @current-change="getDataList"
                :current-page.sync="params.pageNo"
                :page-sizes="$pageSizes"
                :page-size.sync="params.pageSize"
                layout="total, sizes, prev, pager, next"
                :total="data.totalCount || 0">
            </el-pagination>
        </div>
        <CouponManage ref="couponManage" @submitSuccess="getDataList" @confirm="manageConfirm"></CouponManage>
        <UpdateConfirm ref="updateConfirm" @submitSuccess="getDataList"></UpdateConfirm>
        <DeleteConfirm ref="deleteConfirm" @submitSuccess="getDataList"></DeleteConfirm>
        <CouponIssue ref="couponIssue" @submitSuccess="issueSuccess"></CouponIssue>
		<CouponIssueTequan ref="CouponIssueTequan" @submitSuccess="issueSuccess"></CouponIssueTequan>
        <CodeView ref="codeView"></CodeView>
		<CreateCode ref="CreateCode" @onUpdate="getDataList"></CreateCode>
    </div>
</template>

<script>
import CouponManage from './components/CouponManage'
import UpdateConfirm from './components/UpdateConfirm'
import DeleteConfirm from './components/DeleteConfirm'
import CouponIssue from './components/CouponIssue'
import CouponIssueTequan from './components/CouponIssueTequan'
import CodeView from '@/components/CodeView';
import CreateCode from './components/CreateCode';
export default {
    components:{CouponManage, UpdateConfirm, DeleteConfirm, CouponIssue,CouponIssueTequan, CodeView,CreateCode},
    data(){
        this.defaultParams = {
            // 查询类型 1：ID 2：名称
            type: 1,
            value: null,
            // 时间类型，1：生效时间 2：截止时间
            dateType: 1,
            date: null,
            pageNo: 1,
            pageSize: this.$pageSizes[0],
            couponType: "",
			couponCategory:''
        };

        return {
            data: [],
            dataList: [],
            params:{
                ...this.defaultParams,
                type: parseInt(this.$route.query.type || 1),
                value: this.$route.query.value || null,
                dateType: parseInt(this.$route.query.dateType || 1),
                date: this.$route.query.startDate && this.$route.query.endDate ? [this.$route.query.startDate, this.$route.query.endDate] : null,
                pageNo: parseInt(this.$route.query.pageNo || 1),
                pageSize: parseInt(this.$route.query.pageSize || this.$pageSizes[0]),
                couponType: parseInt(this.$route.query.couponType) || "",
				couponCategory: parseInt(this.$route.query.couponCategory) || "",
            },
            listLoading: true,
            sswap:process.env.VUE_APP_SSWAP_URL,
            copyUrl: "",
            copyTimer: null,
            category:{
                1: '演出',
                2: '众筹',
                3: '周边',
                4: '演出/众筹',
                5: '演出/周边',
                6: '演出/众筹/周边',
                7: '众筹/周边'
            },
			link:''
        }
    },
    mounted() {
        this.getDataList();
    },
    methods:{
        //库存展示：0 或未返回视为不限制
        stockView(stock) {
            return stock ? stock : '不限';
        },
        //获取列表
        async getDataList() {
            const {date, ...filterData} = this.params;
            const [startDate, endDate] = date || [];

            this.listLoading = true;

            const res = await this.$request({
                url: '/coupon/list',
                method: 'post',
                data: {...filterData, startDate, endDate}
            }).catch(() => {
                return {data: {state: '0', msg: '请求错误'}};
            }).finally(() => {
                this.listLoading = false;
            });

            const { state, msg, result } = res.data;

            if(state !== '1') {
                return this.$message.error(msg || '请求失败');
            }

            this.data = result;
            this.dataList = result.result || [];
            this.dataList.map(item => {
                item.qrCodeUrl = `${this.sswap}/pages/coupon/receive/receive?id=${item.code}`
            })
        },
         //选择pageSize
        handleSizeChange(e) {
            this.params.pageNo = 1;
            this.params.pageSize = e;
            this.getDataList();
        },
        //搜索
        search() {
            this.params.pageNo = 1;
            this.getDataList();
        },
        //重置搜索
        reset() {
            this.params = {
                ...this.defaultParams,
                pageSize: this.params.pageSize,
            };
            this.getDataList();
        },
        // 创建优惠券
        addCoupon() {
            this.$refs.couponManage.show();
        },
        // 管理
        manage(row) {
            this.$refs.couponManage.show(row);
        },
        // 管理确认
        manageConfirm(data) {
            this.$refs.updateConfirm.show(data);
        },
		createCode(data){
			//设置了库存（stock > 0）的优惠券不可生成兑换码
			if (data && data.stock > 0) {
				return this.$message.error('无库存优惠券才可生成兑换码');
			}
			this.$refs.CreateCode.show(data);
		},
        // 删除确认
        async delConfirm(row) {
            const {id} = row;

            const flag = await this.$confirm('确定要删除该优惠券吗?', '确认删除', {
                confirmButtonText: '确认删除',
                cancelButtonText: '取消',
                type: 'warning',
                center: true,
                closeOnClickModal: false
            }).catch(() => {
                return 'cancel';
            });

            if(flag === 'cancel') {
                return;
            }

            // 验证优惠券是否存在已经被用户领取
            const res = await this.$request({
                url: '/coupon/validate',
                method: 'post',
                params: {id}
            }).catch(() => {
                return {data: {state: '0', msg: '请求错误'}};
            });

            const { state, msg, result } = res.data;

            if(state !== '1') {
                this.$message.error(msg || '请求失败');
                return ;
            }
            
            // 二次确认
            if(result.unUseCount > 0) {
                this.$refs.deleteConfirm.show(id);
                return ;
            }

            // 删除请求
            this.del(id);
        },
        // 删除
        async del(id) {
            const res = await this.$request({
                url: '/coupon/delete',
                method: 'post',
                data: {id}
            }).catch(() => {
                return {data: {state: '0', msg: '请求错误'}};
            });

            const { state, msg } = res.data;

            if(state !== '1') {
                this.$message.error(msg || '请求失败');
                return ;
            }

            this.getDataList();
        },
        // 发放
        issue(row) {
            this.$refs.couponIssue.show(row);
        },
		//发送  特权优惠券
		issueTequan(row){
			this.$refs.CouponIssueTequan.show(row);
		},
        async issueSuccess() {
            // await this.$alert('发放完成', '提示', {
            //     confirmButtonText: '确认',
            //     type: 'success',
            //     center: true
            // });

            this.getDataList();
        },
        // 使用明细
        viewUsageDetails(row) {
            const {id} = row;
            this.$router.push({path: `/promotion/showCoupon/usageDetails/${id}`});
        },
		//兑换码明细
		redemptionDetail(){
			this.$router.push({path: `/promotion/showCoupon/redemptionDetail`});
		},
		//用户画像
		userProfile(row){
			const {id} = row;
			this.$router.push({path: `/promotion/showCoupon/userProfile/${id}`});
		},
        //领取地址
		viewLink(row){
			this.$request({
				url: "/coupon/generateRedBookUrl",
				method: "POST",
				params: {
					id:row.id
				},
			})
				.then((res) => {
					const { state, msg, result } = res.data;
					if (state == 1 && result) {
						this.link = result						
						this.$refs.codeView.show({
						    ...row,
							Link:this.link
						})						
						
					} else {
						this.$message.error(msg || "请求失败");
					}
				})
				.catch(() => {
					this.$message.error("请求错误");
				})
				.finally(() => {
					this.listLoading = false;
				});				
		},
    }
}
</script>

<style lang="scss" scoped>
</style>